import { TYPES } from "../../../../types/types"

export const postRequest = {
    method:'post',
    needsToBeStored: true,
    storeType: 'blob',
    url:'api/reportes/export-report',
    data: {},
    headers:{
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':'Bearer ' + localStorage.getItem('token')
    }
}
